import React, { ChangeEvent, useRef, useState } from "react";

const FileUploader = ({ onFileSelect }) => {
  const [files, setFiles] = useState([]);

  const onChange = (e) => {
    var files = e.target.files;
    var filesArr = Array.prototype.slice.call(files);
    setFiles({ files: [...files, ...filesArr] });
    onFileSelect(files);
  };

  const removeFile = (selectedFile) => {
    setFiles(
      files.filter((x) => x !== selectedFile),
    );
  };

  return (
      <label className="btn btn-primary rounded-md" style={{ marginBottom: '0' }}>
        <input type="file" onChange={onChange} hidden />
        Upload
      </label>
    //https://codesandbox.io/s/xnxmzxbe?file=/index.js:119-208
  );
};

export default FileUploader;
